import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/edit.svg";
var EditSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  EditSolid_default as default
};
